import { PhoneNumberWithPrefixSchema } from "@modules/box/boxTypes"
import { ExperienceLevel, Goals, HeardAboutUs, LeadType } from "@modules/boxLead/entities/boxLeadTypes"
import { z } from "zod"

export const BoxLeadInputDtoSchema = z
  .object({
    userId: z.string().nullish(),
    experienceLevel: z.enum(ExperienceLevel).nullish(),
    goals: z.array(z.enum(Goals)).nullish(),
    hearAboutUs: z.enum(HeardAboutUs).nullish(),
    hearAboutUsSpecify: z.string().max(255).nullish(),
    bestTimeToContact: z.string().max(255).nullish(),
    madeByStaffId: z.string().nullish(),
    firstname: z.string().max(64).nullish(),
    lastname: z.string().max(64).nullish(),
    email: z.email().max(320).nullish(),
    phoneNumber: PhoneNumberWithPrefixSchema.nullish(),
    note: z.string().max(255).nullish(),
    firstContact: z.iso.datetime(),
    leadType: z.enum(LeadType),
  })
  .refine((data) => {
    if (!data.userId && (!data.firstname || !data.lastname)) {
      return false
    }
    return true
  })
  .meta({ id: "BoxLeadInputDtoSchema" })

export type BoxLeadInputDto = z.infer<typeof BoxLeadInputDtoSchema>
